import type * as React from "react";
import * as PriceUtils from "../../../utils/PriceUtils";
import { type PriceData } from "../../../models/PriceData";

export interface PriceFormatProps {
  className?: string;
  price: PriceData;
  /**
   * Calculate the price with this multiplier
   * @todo Remove
   * @deprecated
   */
  multiplier?: number;
  showZero?: boolean;
  zeroText?: string;
}
export const PriceFormat: React.FC<PriceFormatProps> = (props) => {
  const price = props.multiplier !== undefined ? PriceUtils.multiply(props.price, props.multiplier) : props.price;
  const textPrice = props.showZero ? PriceUtils.nonVolatileText(price) : PriceUtils.text(price, props.zeroText);

  return <span className={props.className}>{textPrice}</span>;
};
